import script from "./CheckoutDeliverableItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutDeliverableItems.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutDeliverableItems.vue?vue&type=style&index=0&id=f65f9de4&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65f9de4"]])

export default __exports__